// A magic-link token is single-use, and the tokenised URL stays reachable after it is redeemed, so
// re-mounting the magic-link route must not replay it. Module scope rather than a ref, so the claim
// survives that re-mount.
const attemptedTokens = new Set<string>();

export const claimTokenRedemption = (token: string): boolean => {
  if (attemptedTokens.has(token)) {
    return false;
  }

  attemptedTokens.add(token);
  return true;
};
